import { BASE_URL } from "@/constants/config";
import {request} from "@/utils/request";

export const COVERYEARS_ENDPOINTS = {

  coveryear: (id) => `${BASE_URL}api/coveryears/${id}/`,
  get_coveryears: `${BASE_URL}api/coveryears/`,

  coveryears: `${BASE_URL}api/taux_coveryear/`,
  coveryear_taux: `${BASE_URL}api/taux_coveryear/taux/`,
  update_coveryears_taux: (id) => `${BASE_URL}api/taux_coveryear/${id}/`,
  download_template_taux: `${BASE_URL}api/taux_coveryear/download_template_taux/`,
  inject_coveryear_taux: `${BASE_URL}api/taux_coveryear/upload_coveryear/`,
  download_coveryear_taux: `${BASE_URL}api/taux_coveryear/download_coveryear_taux/`,

  coveryear_CCR: `${BASE_URL}api/CCR_coveryear/CCR/`,
  update_coveryears_CCR: (id) => `${BASE_URL}api/CCR_coveryear/${id}/`,
  download_template_CCR: `${BASE_URL}api/CCR_coveryear/download_template_CCR/`,
  inject_coveryear_CCR: `${BASE_URL}api/CCR_coveryear/upload_coveryear/`,
  download_coveryear_CCR: `${BASE_URL}api/CCR_coveryear/download_coveryear_CCR/`,

  coveryear_CCR_threshold: `${BASE_URL}api/CCR_threshold_coveryear/CCR_threshold/`,
  update_coveryears_CCR_threshold: (id) => `${BASE_URL}api/CCR_threshold_coveryear/${id}/`,
  download_template_CCR_threshold: `${BASE_URL}api/CCR_threshold_coveryear/download_template_CCR_threshold/`,
  inject_coveryear_CCR_threshold: `${BASE_URL}api/CCR_threshold_coveryear/upload_coveryear/`,
  download_coveryear_CCR_threshold: `${BASE_URL}api/CCR_threshold_coveryear/download_coveryear_CCR_threshold/`,

  coveryear_CCR_group: `${BASE_URL}api/CCR_group_coveryear/CCR_group/`,
  download_coveryear_CCR_group: `${BASE_URL}api/CCR_group_coveryear/download_coveryear_CCR_group/`,

  all_coveryear_member: (id_coveryear) => `${BASE_URL}api/member_coveryear/members/${id_coveryear}/`,
  update_coveryear_member: (id) => `${BASE_URL}api/member_coveryear/coveryear_member/${id}/`,
  download_coveryear_members_template: `${BASE_URL}api/member_coveryear/download_template/`,
  inject_coveryear_members: `${BASE_URL}api/member_coveryear/upload_coveryear_members/`,
  download_coveryear_members: `${BASE_URL}api/member_coveryear/download_coveryear_members/`,
};

class CoverYears {
  async fetchCoverYears() {
    const { data } = await request({
      url: COVERYEARS_ENDPOINTS.coveryears,
      query: {order_by: 'date_start'}
    });
    return data;
  }

  async fetchCoverYear(id) {
    return request({
      url: COVERYEARS_ENDPOINTS.coveryear(id),
    });
  }

  async createCoverYear(payload){
    return await request({
      url: COVERYEARS_ENDPOINTS.coveryears,
      method: "POST",
      body: payload,
    });
  }

  async updateCoverYearTaux(id, payload) {
    return await request({
      url: COVERYEARS_ENDPOINTS.update_coveryears_taux(id),
      method: 'PUT',
      body: payload
    });
  }
  async updateCoverYearCCR(id, payload) {
    return await request({
      url: COVERYEARS_ENDPOINTS.update_coveryears_CCR(id),
      method: 'PUT',
      body: payload
    });
  }
  async updateCoverYearCCRThreshold(id, payload) {
    return await request({
      url: COVERYEARS_ENDPOINTS.update_coveryears_CCR_threshold(id),
      method: 'PUT',
      body: payload
    });
  }
}

export const CoverYearServices = new CoverYears();
